<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractEvents"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    :name="gridName"
    :headerTitle="documentTitle"
    :items="ds"
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DateRangeSelector
        name="contractEventFilters"
        :from="dsParams.date_from"
        :to="dsParams.date_to"
        size="sm"
        @changed="evh_6466705138206980_changed($event, {})"
      >
      </DateRangeSelector>
      <PageHelp
        path="/general/jobs.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "contractEvents",
    path: "/contract-events",
    component: "ContractEvents"
  }
)

@Component()
export default class ContractEvents extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "ContractEvents.dsParams");
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  dsParams!: any;

  async $$load_dsParams() {
    return {
      date_from: this.$fn.today(),
      date_to: null,
    }
  }

  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('browse_contract_events', {
      parameters: () => this.dsParams
    })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['gridName', 'dsParams', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "contractEvents",
        dsParams: null,
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "event_name",
          type: "command",
          name: this.$fn.pgettext("ContractEvents", "Name"),
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("ContractEvents", "Description"),
        }
          ,
        {
          field: "contract",
          name: this.$fn.pgettext("ContractEvents", "Contract"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    {{ $value.contract_number }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              params: {
                id: "contract.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "timestamp",
          name: this.$fn.pgettext("ContractEvents", "Timestamp"),
          formatter: {
            name: "datetime",
          }
          ,
        }
          ,
        {
          field: "identity",
          name: this.$fn.pgettext("ContractEvents", "User"),
          formatter: {
            name: "user",
          }
          ,
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("ContractEvents|Title", "Contract Events"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7288_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7288, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_7290_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_7290, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_7292_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7292, alias=undefined
    return {
      name: "DataViewerModal",
      props: {
        content: $event.data.data.event_data,
        mode: "json",
      }
      ,
    }
  }

  async evh_2248226175642056_command_7291_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7291, alias=undefined
    return $event.data.column.id === 'event_name'
  }

  async act_2248226175642056_showModal_7294_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7294, alias=undefined
    return {
      name: "Job",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_7293_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7293, alias=undefined
    return $event.data.column.id === 'number'
  }

  async act_2248226175642056_showModal_7296_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7296, alias=undefined
    return {
      name: "Job",
      props: {
        oid: $event.data.data.parent_id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_7295_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7295, alias=undefined
    return $event.data.column.id === 'parent_number'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_setData_7298_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_7298, alias=undefined
    return {
      path: "dsParams.date_from",
      value: $event.data[0],
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_6466705138206980_setData_7300_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_7300, alias=undefined
    return {
      path: "dsParams.date_to",
      value: $event.data[1],
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_6466705138206980_reloadSlickgrid_7302_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6466705138206980_reloadSlickgrid_7302, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_6466705138206980_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_changed.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7288: actions.CloseModalAction;
    evh_7315092382398562_close_7287: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_7290: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_7289: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_showModal_7292: actions.ShowModalAction;
    evh_2248226175642056_command_7291: actions.EventHandlerImpl;
    act_2248226175642056_showModal_7294: actions.ShowModalAction;
    evh_2248226175642056_command_7293: actions.EventHandlerImpl;
    act_2248226175642056_showModal_7296: actions.ShowModalAction;
    evh_2248226175642056_command_7295: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_6466705138206980_setData_7298: actions.SetDataAction;
    evh_6466705138206980_changed_7297: actions.EventHandlerImpl;
    act_6466705138206980_setData_7300: actions.SetDataAction;
    evh_6466705138206980_changed_7299: actions.EventHandlerImpl;
    act_6466705138206980_reloadSlickgrid_7302: actions.ReloadSlickgridAction;
    evh_6466705138206980_changed_7301: actions.EventHandlerImpl;
    evh_6466705138206980_changed: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7288 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7288_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7287 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7288,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7287],
      }
    );
    const act_2248226175642056_setData_7290 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_7290_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_7289 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_7290,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_7289],
      }
    );
    const act_2248226175642056_showModal_7292 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7292_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7291 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7292,
        event: "command",
        when: this.evh_2248226175642056_command_7291_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_showModal_7294 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7294_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7293 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7294,
        event: "command",
        when: this.evh_2248226175642056_command_7293_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_showModal_7296 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7296_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7295 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7296,
        event: "command",
        when: this.evh_2248226175642056_command_7295_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_7291, evh_2248226175642056_command_7293, evh_2248226175642056_command_7295],
      }
    );
    const act_6466705138206980_setData_7298 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_7298_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_changed_7297 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_7298,
        event: "changed",
        displayName: "setData",
      }
    );
    const act_6466705138206980_setData_7300 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_7300_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_changed_7299 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_7300,
        event: "changed",
        displayName: "setData",
      }
    );
    const act_6466705138206980_reloadSlickgrid_7302 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6466705138206980_reloadSlickgrid_7302_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_changed_7301 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_reloadSlickgrid_7302,
        event: "changed",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_6466705138206980_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_changed_7297, evh_6466705138206980_changed_7299, evh_6466705138206980_changed_7301],
      }
    );
    return {
      act_7315092382398562_closeModal_7288,
      evh_7315092382398562_close_7287,
      evh_7315092382398562_close,
      act_2248226175642056_setData_7290,
      evh_2248226175642056_selectedRowsChanged_7289,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_showModal_7292,
      evh_2248226175642056_command_7291,
      act_2248226175642056_showModal_7294,
      evh_2248226175642056_command_7293,
      act_2248226175642056_showModal_7296,
      evh_2248226175642056_command_7295,
      evh_2248226175642056_command,
      act_6466705138206980_setData_7298,
      evh_6466705138206980_changed_7297,
      act_6466705138206980_setData_7300,
      evh_6466705138206980_changed_7299,
      act_6466705138206980_reloadSlickgrid_7302,
      evh_6466705138206980_changed_7301,
      evh_6466705138206980_changed,
    }
  }
}

Vue.component("ContractEvents", ContractEvents);

</script>